import {
  collection,
  doc,
  setDoc,
  updateDoc,
  deleteDoc,
  onSnapshot,
  getDoc,
  UpdateData
} from "firebase/firestore";

import { db } from "@/app/providers/Firebase";
import { User } from "@/models/User";

const COLLECTION = "users";

function mapDoc<T>(snap: any): T {
  return {
    id: snap.id,
    ...snap.data()
  } as T;
}

export const userRepository = {
  async getById(id: string): Promise<User | null> {
    const snap = await getDoc(doc(db, COLLECTION, id));

    if (!snap.exists()) return null;

    return mapDoc<User>(snap);
  },

  async create(user: User): Promise<User> {
    await setDoc(doc(db, COLLECTION, user.id), user);
    return user;
  },

  async update(id: string, data: UpdateData<User>) {
    await updateDoc(doc(db, COLLECTION, id), data);
  },

  async delete(id: string) {
    await deleteDoc(doc(db, COLLECTION, id));
  },

  subscribe(id: string, cb: (user: User | null) => void) {
    return onSnapshot(doc(db, COLLECTION, id), snap => {
      if (!snap.exists()) {
        cb(null);
      } else {
        cb(mapDoc<User>(snap));
      }
    });
  },

  subscribeAll(cb: (users: User[]) => void) {
    return onSnapshot(collection(db, COLLECTION), snap => {
      const users = snap.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      })) as User[];

      cb(users);
    });
  }
};
